// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
  apiKey: "AIzaSyAdMf3g9ixa8AFe2nzhERaa9TJTAUf66nw",
  authDomain: "backecommerce-9d0dc.firebaseapp.com",
  projectId: "backecommerce-9d0dc",
  storageBucket: "backecommerce-9d0dc.firebasestorage.app",
  messagingSenderId: "51605600316",
  appId: "1:51605600316:web:733360fcb02827bdd6ab39",
  measurementId: "G-XSHL9VTHFZ"
}

};
